import { enqueueSnackbar, OptionsObject } from "notistack";
import { isAxiosError } from "axios";
import { snackbarAction } from "./_snackbar-action";

/** Lanzar este error en onSubmit muestra el notify especificado y cancela el submit sin mostrar toast adicional. */
export class SilentSubmitError extends Error {
    constructor() { super("SilentSubmitError"); }
}

export function notify(message: string, options?: OptionsObject) {
    enqueueSnackbar(message, { variant: "success", action: snackbarAction, ...options });
}

export const extractMessageFromError = (error: unknown) => {
    const mode = import.meta.env.MODE;
    if(mode === "development") console.log(error);

    //Handle axios errors
    if (isAxiosError(error)) {
        if(error.response){
            if (error.response.data && typeof error.response.data === "string")
                return error.response.data;

            if (error.response.data && typeof error.response.data === "object") {
                const data = error.response.data as Record<string, unknown>;
                if ("message" in data) return String(data.message);
                if ("error" in data) return String(data.error);
                if ("errors" in data && typeof data.errors === "object" && data.errors !== null) {
                    const firstErrors = Object.values(data.errors as Record<string, string[]>);
                    if (firstErrors.length > 0 && Array.isArray(firstErrors[0]) && firstErrors[0].length > 0)
                        return firstErrors[0][0];
                }
                if ("title" in data) return String(data.title);
            }

            switch (error.response.status) {
                case 400: return "Parametros inválidos.";
                case 401: return "No estas autenticado.";
                case 403: return "No tienes los permisos necesarios.";
                case 404: return "No se ha podido encontrar el recurso pedido.";
                case 500: return "Hubo un error de servidor.";
            }
        }
        if(error.request){
            return "Error de conexión."
        }
    }

    //Handle Normal Errors
    if (error instanceof Error && error.message)
        return error.message;

    if (error instanceof Object && "message" in error)
        return String(error.message);

    const errorString = String(error);
    if(errorString) return errorString;

    return "Hubo un error inesperado.";
}

export function notifyError(error?: unknown, options?: OptionsObject) {
    enqueueSnackbar(extractMessageFromError(error), { variant: "error", action: snackbarAction, ...options });
}
